import { useForm } from "react-hook-form";
import { useNavigate } from "react-router-dom";
import { validateNIF } from "../../helpers/utils.js";
import { yupResolver } from '@hookform/resolvers/yup';
import * as Yup from 'yup';

const ValidarNif = (props) => {
  const formSchema = Yup.object().shape({
    nif: Yup.string()
      .required('O número de identificação fiscal (NIF) é obrigatório.')
      .length(9, 'O número de identificação fiscal (NIF) tem de ter 9 caracteres.')
      // .matches(/^[0-9]+$/, 'NIF inválido'),
      .test('validateNif', 'Número de identificação fiscal (NIF) inválido', function(value) {
        return validateNIF(value);
      }),
    termos: Yup.boolean()
      .oneOf([true], 'Tem de aceitar a política de tratamento de dados.'),
  })
  const formOptions = { resolver: yupResolver(formSchema), mode:"onChange" }

  const { register, handleSubmit, formState: { errors, isValid } } = useForm(formOptions);

  const isButtonEnabled = isValid

  let navigate = useNavigate(); 

  const handleInputChange = (event) =>{
    const nifNums = event.target.value.replace(/[^0-9]/g, '');
    event.target.value = nifNums;
  }

  const redirectToHelp = () =>{ 
    navigate('/ajuda');
  }

  return (
    <div className="mt-5">
      <form onSubmit={handleSubmit(props.onSubmitHandler)}>
        <div className="form-group">
          <label>Número de identificação fiscal (NIF)</label>
          <input type="text" {...register("nif")} className={`form-control ${(errors.nif) ? 'is-invalid' : ''}`} onInput={handleInputChange}/>
          <div className="invalid-feedback">{errors.nif?.message}</div>
        </div>
        {props.checkRequest && (
        <div className="form-check mt-5">
          <input type="checkbox" {...register("termos")} className={`form-check-input ${errors.termos ? 'is-invalid' : ''}`} />
          <label className="form-check-label">Li e aceito a política de <a href="https://www.cgd.pt/Site/CXA/CGD-Pensoes/Pages/Politica-de-Privacidade.aspx" target="_blank" rel="noopener noreferrer">tratamento de dados.</a></label>
          <div className="invalid-feedback">{errors.termos?.message}</div>
        </div>
        )}
        <div className="mt-5">
          <button type="submit" className="btn btn-primary me-4" disabled={!isButtonEnabled}>
            Continuar
          </button>
          <button type="button" className="btn btn-secondary" 
            onClick={() => redirectToHelp()}
          >
            Pedir ajuda
          </button>
        </div>
      </form>
    </div>
  );
};

export default ValidarNif;
